'use strict'
const rendererHOC = require('../../components/RendererHOC')
const constants = require('../../utils/constants')
const {withActions} = require('carmi-host-extensions')

const name = 'ComponentsRenderAspect'
let eventsManager // eslint-disable-line santa/no-module-state

const defaultModel = {
    compRefs: {}
}

function init(aspectActions, {eventsManager: eventsManagerProp}) {
    eventsManager = eventsManagerProp
}

const functionLibrary = {
    wrapWithRendererHOC: component => rendererHOC(component),
    dispatchComponentRenderState: (compId, isRendering) => {
        eventsManager.emit(constants.EVENTS.COMP_RENDER_STATE_CHANGE, compId, isRendering)
    },
    updateCompRef: withActions((aspectActions, id, element) => {
        if (element === null) {
            aspectActions.setCompRef(id, undefined)
        } else {
            aspectActions.setCompRef(id, element)
        }
    })
}

module.exports = {
    init,
    name,
    defaultModel,
    functionLibrary
}
